import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LoginService } from '../login/login.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent implements OnInit {
  private router = inject(Router);
  private cookies = inject(CookieService);
  private loginService = inject(LoginService);

  logout = true;
  loading = true;
  message = '';
  MCValue = '';
  ETValue = '';

  constructor() {
    this.cookies.set('MC', '', 0, '/', 'fidelity.com', true, 'None');
    this.cookies.set('MC', '', 0, '/', 'fmr.com', true, 'None');
  }

  ngOnInit() {
    this.MCValue = this.cookies.get('MC');
    this.ETValue = this.cookies.get('ET');
    this.cookies.delete('MC', '/', '.fmr.com', true, 'None');
    this.cookies.delete('MC', '/', '.fidelity.com', true, 'None');
    this.cookies.delete('MC', '/', 'fidelityprime.com', true, 'None');
    this.cookies.delete('MC');
    this.cookies.delete('SC', '/', '.fidelity.com', true, 'None');
    this.cookies.delete('FC', '/', '.fidelity.com', true, 'None');
    this.cookies.delete('RC', '/', '.fidelity.com', true, 'None');
    this.cookies.delete('SC', '/', 'fidelityprime.com', true, 'None');
    this.cookies.delete('FC', '/', 'fidelityprime.com', true, 'None');
    this.cookies.delete('RC', '/', 'fidelityprime.com', true, 'None');
    this.cookies.delete('SC', '/', '.fidelityprime.com', true, 'None');
    this.cookies.delete('FC', '/', '.fidelityprime.com', true, 'None');
    this.cookies.delete('RC', '/', '.fidelityprime.com', true, 'None');

    this.retryLogout();
  }
  returnToLogin() {
    this.cookies.delete('MC');
    this.cookies.delete('MC', '/', '.fmr.com', true, 'None');
    this.cookies.delete('MC', '/', '.fidelity.com', true, 'None');
    this.cookies.delete('MC', '/', 'fidelityprime.com', true, 'None');
    this.cookies.delete('ET', '/', '.fmr.com', true, 'None');
    this.cookies.delete('ET', '/', '.fidelity.com', true, 'None');
    this.cookies.delete('ET', '/', 'fidelityprime.com', true, 'None');
    this.router.navigate(['login']);
  }
  retryLogout() {
    this.loginService.sessionLogout().subscribe((resp: any) => {
      if (resp === null) {
        this.logout = true;
        this.cookies.delete('MC', '/', '.fmr.com', true, 'None');
        this.cookies.delete('MC', '/', '.fidelity.com', true, 'None');
        this.cookies.delete('ET', '/', '.fmr.com', true, 'None');
        this.cookies.delete('ET', '/', '.fidelity.com', true, 'None');
        this.loading = false;
      } else {
        this.message = ((resp.responseBaseInfo || {}).status || {}).message || '';
        this.logout = false;
        this.loading = false;
      }
    });
    this.loading = false;
  }
}
